import { Trans } from "@lingui/macro";
import { Typography, Box, Card,  } from "@mui/material"

export const EmailVerified = () => {
    return (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
            height: "100vh"
            }}>
            <Card sx={{textAlign: "center", padding: "2rem", margin: "2rem"}}>
                <Typography sx={{fontSize: "1.8rem"}} variant="body1"><Trans>{`Thank you for subscribing to our newsletter!`}</Trans></Typography>
                <Typography sx={{fontSize: "1.8rem"}} variant="body1"><Trans>{`You can close this tab.`}</Trans></Typography>
            </Card>
        </Box>
    )
}